import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/core/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  userid(userid: any) {
    throw new Error('Method not implemented.');
  }

  constructor(
    private httpService: HttpService,

  ) { }

  //  getall banners api 
  getbanners(model: string): Observable<any> {
    return this.httpService.post('getList', {
      "model": "Banners",
    });
  }
  // sociallinks api 
  getsociallinks(model: string): Observable<any> {
    return this.httpService.post('getList', {
      "model": "SocialLinks",
    });
  }
  //news&events api
  getnews(model: string): Observable<any> {
    return this.httpService.post('getList', {
      "model": "News",
    });
  }
  // Menu  aggredaed data report api
  getAggregate(): Observable<any> {
    return this.httpService.get('disabilityStateAggrigateReport')
  }
  // video gallery menu album  api 
  getVideoCategories(model: string): Observable<any> {
    return this.httpService.post('getList', {
      "model": "VideoCategories",
    });
  }
  // video gallery sub videos api
  getvideo(model: string): Observable<any> {
    return this.httpService.post('getList', {
      "model": "Videos",
    });
  }

  //photo gallery menu album api
  getPhotoCategories(model: string): Observable<any> {
    return this.httpService.post('getList', {
      "model": "PhotoCategories",
    });
  }
  // video gallery sub photos api
  getphotos(model: string, categoryId: number): Observable<any> {
    return this.httpService.post('getList', {
      "model": "Photos",
      "filters": { "photo_categories_id": categoryId }
    });
  }

  // districtwallfareoffice menu show data call api
  getdistrictwallfareoffice(): Observable<any> {
    return this.httpService.post('districwellfareoffice', {});
  }
  //schemes menu data show api
  getdisabilityscheme(): Observable<any> {
    return this.httpService.post('getSchemes', {});
  }
  //Medicalcamps menu data show api
  getmedicalcamps(): Observable<any> {
    return this.httpService.post('getMedicalcamps', {});
  }
  //nearestMedicalAuthority menu data show api
  getnearestMedicalAuthority() {
    return this.httpService.get('nearestMedicalAuthority', {});
  }
  // track appplication menu data show api 
  // gettrackapplicaion(data: FormData){
  //   return this.httpService.post('trackapplication', {
  //     "username": "userid",
  //   });
  // }
  // getdispatchdata(): Observable<any> {
  //   return this.httpService.post('getDashboarddata', {});
  // }

  getTrackApplication(data: any): Observable<any> {
    return this.httpService.post('trackapplication', data
    );
  }

  getDispatchData(params: object): Promise<any[]> {
    return this.httpService.post('getDashboarddata', JSON.stringify(params)).toPromise();
  }

  getstatewiswcordinatorData(params: object): Promise<any[]> {
    return this.httpService.post('statecoordinatorlist', JSON.stringify(params)).toPromise();
  }
  getpendingreportsmonthswise(params: object): Promise<any[]> {
    return this.httpService.post('pendingreportsmonthswise', JSON.stringify(params)).toPromise();
  }
  getstatewisereportdata(params: object): Promise<any[]> {
    return this.httpService.post('statepwdreport', JSON.stringify(params)).toPromise();
  }

  getDashboardMapData(params: object): Promise<any[]> {
    return this.httpService.post('getDashboardMapdata', JSON.stringify(params)).toPromise();
  }
}
